import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { ReferenceConfiguration } from '../../job-service/service-models/reference-configuration';
import { Reference } from '../../applicant-service/service-models/reference';
import * as _ from 'lodash';


@Component({
  selector: 'app-reference',
  templateUrl: './reference.component.html',
  styleUrls: ['./reference.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class ReferenceComponent implements OnInit {

  @Input()
  index: number;
  @Input()
  reference: Reference;
  @Input()
  configuration: ReferenceConfiguration;
  randomNumber: number;
  phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

  constructor() {
    this.randomNumber = Math.random();
  }

  ngOnInit() {
  }

  unmaskPhoneNumber(val) {
    return val.replace(/\D+/g, '');
  }
}
